<template>
  <div>
    <div>医院管理</div>
    <div style="margin-top: 16px">患者端、医生端注册医院选择列表管理</div>
    <el-card style="margin-top: 16px">
      <el-form
        ref="form"
        :model="formAddHospital"
        :rules="formRules"
        label-width="130px"
        style="margin-top: 16px"
      >
        <el-form-item label="医院名称" prop="name">
          <el-input
            v-model="formAddHospital.name"
            maxlength="100"
            clearable
            style="width: 360px"
            placeholder="请输入医院名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="患者端邀请码" prop="ivCode">
          <el-input
            v-model="formAddHospital.ivCode"
            maxlength="32"
            clearable
            style="width: 360px"
            placeholder="留空则自动生成"
          ></el-input>
        </el-form-item>
        <el-form-item label="注册列表排序" prop="sort">
          <el-input-number
            v-model="formAddHospital.sort"
            :min="0"
            :max="9999"
            controls-position="right"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="默认服务医生" prop="defaultDoctorPhone">
          <el-input
            v-model="formAddHospital.defaultDoctorPhone"
            maxlength="20"
            clearable
            style="width: 360px"
            placeholder="用于医生端注册时选择服务人员"
          ></el-input>
        </el-form-item>
        <el-form-item label="医院管理端 H5">
          <el-checkbox v-model="formAddHospital.createHospitalAdmin">
            同时开通
          </el-checkbox>
        </el-form-item>
        <el-form-item label="是否开通短信通知">
          <el-checkbox v-model="formAddHospital.isOpenSmsNotify" true-label="1" false-label="0">
            开通短信通知（训练方案生成时将通知患者）
          </el-checkbox>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :loading="submitting" @click="onSubmit">新增医院</el-button>
          <el-button @click="resetForm">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <el-table :data="tableDataHospitals" border style="width: 100%;margin-top: 16px">
      <el-table-column prop="id" label="注册记录ID" width="100"></el-table-column>
      <el-table-column prop="name" label="医院名称" min-width="180"></el-table-column>
      <el-table-column prop="hospitalId" label="业务医院ID" width="100"></el-table-column>
      <el-table-column label="当前状态" width="90">
        <template slot-scope="scope">
          <span
            style="margin-left: 10px"
            :style="{ 'color': scope.row.active ? '#04ab04' : '#fd4e4e' }"
          >
            {{
            scope.row.active ?
            '已开通' : '未开通' }}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="是否显示" width="90">
        <template slot-scope="scope">
          <span style="margin-left: 10px">{{ scope.row.show ? '显示' : '隐藏' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="inviteCode" label="邀请码" width="180"></el-table-column>
      <el-table-column prop="sort" label="排序"></el-table-column>
      <el-table-column label="短信通知" width="120">
        <template slot-scope="scope">
          <span :style="{ color: scope.row.isOpenSmsNotify ? 'green' : 'red' }">
            {{ scope.row.isOpenSmsNotify ? '已开通' : '已关闭' }}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="小程序 WebView" width="170">
        <template slot-scope="scope">
          <el-tag
            v-if="scope.row.wxMiniAppWebModel"
            type="success"
            size="mini"
          >已添加</el-tag>
          <el-button
            v-else
            type="primary"
            size="mini"
            @click="addWxMiniAppWebModel(scope.row)"
          >添加</el-button>
        </template>
      </el-table-column>
      <el-table-column label="医院管理权限" width="160">
        <template slot-scope="scope">
          <el-button
            type="text"
            size="small"
            @click="toggleSmsNotify(scope.row)"
            :style="{ color: scope.row.isOpenSmsNotify ? '#f56c6c' : '#67c23a' }"
          >{{ scope.row.isOpenSmsNotify ? '关闭短信' : '开启短信' }}</el-button>
          <el-button
            type="text"
            size="small"
            @click="openHospitalAdminDialog(scope.row)"
          >添加管理人员</el-button>
          <el-button
            type="text"
            size="small"
            @click="openHospitalAdminListDialog(scope.row)"
          >查看管理员</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-card style="margin-top: 24px">
      <div style="font-weight: 600;margin-bottom: 12px">训练方案短信控制测试</div>
      <el-input
        v-model="testPatientPhone"
        clearable
        maxlength="20"
        placeholder="输入患者手机号搜索"
        style="width: 280px;margin-right: 8px"
        @keyup.enter.native="searchTestPatient"
      ></el-input>
      <el-button :loading="testPatientSearching" @click="searchTestPatient">搜索患者</el-button>
      <el-table
        v-if="testPatients.length"
        :data="testPatients"
        border
        style="margin-top: 16px"
      >
        <el-table-column prop="realname" label="患者姓名" min-width="120"></el-table-column>
        <el-table-column prop="phone" label="手机号" min-width="140"></el-table-column>
        <el-table-column prop="hospital" label="所属医院" min-width="160">
          <template slot-scope="scope">
            {{ scope.row.hospitalName }}
          </template>
        </el-table-column>
        <el-table-column label="短信开关" width="110">
          <template slot-scope="scope">
            <span :style="{ color: scope.row.isOpenSmsNotify === true ? '#67c23a' : (scope.row.isOpenSmsNotify === false ? '#f56c6c' : '#909399') }">
              {{ scope.row.isOpenSmsNotify === true ? '已开通' : (scope.row.isOpenSmsNotify === false ? '已关闭' : '未知') }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="130">
          <template slot-scope="scope">
            <el-button
              type="primary"
              size="mini"
              :loading="testingPatientId === scope.row.userId"
              @click="testPlanSms(scope.row)"
            >实际发送测试短信</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div v-else-if="testPatientSearched" style="margin-top: 12px;color: #909399">未找到该手机号对应的患者</div>
    </el-card>

    <el-dialog
      :title="`添加医院管理人员 - ${adminHospital.name || ''}`"
      :visible.sync="hospitalAdminDialogVisible"
      width="520px"
    >
      <el-form label-width="90px">
        <el-form-item label="医院">
          <span>{{ adminHospital.name }}（医院 ID：{{ adminHospital.hospitalId }}）</span>
        </el-form-item>
        <el-form-item label="医生手机号">
          <el-input
            v-model="adminMobiles"
            type="textarea"
            :rows="7"
            placeholder="请输入医生手机号，多个手机号可用换行、逗号或空格分隔"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="hospitalAdminDialogVisible = false">取消</el-button>
        <el-button
          type="primary"
          :loading="adminSubmitting"
          @click="submitHospitalAdmins"
        >确认添加</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :title="`医院管理员 - ${adminListHospital.name || ''}`"
      :visible.sync="hospitalAdminListDialogVisible"
      width="560px"
    >
      <el-table
        v-loading="adminListLoading"
        :data="hospitalAdmins"
        border
        stripe
        empty-text="暂无医院管理员"
      >
        <el-table-column prop="id" label="记录 ID" width="90"></el-table-column>
        <el-table-column prop="mobile" label="手机号" min-width="160"></el-table-column>
        <el-table-column label="角色" width="120">
          <template slot-scope="scope">
            {{ scope.row.role === 1 ? '系统管理员' : '医院管理员' }}
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer">
        <el-button @click="hospitalAdminListDialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>

    <div style="margin-top: 32px">添加医生到注册选择界面</div>
    <div style="display: flex;justify-items: center;margin-top: 16px">
      <div>手机号：</div>
      <el-input style="width: 200px" v-model="phone"></el-input>
      <div>注册医院id</div>
      <el-input style="width: 200px" v-model="hid"></el-input>
      <el-button @click="add">提交</el-button>
    </div>
    <div style="margin-top: 32px">添加医生到医生列表</div>
    <div style="display: flex;justify-items: center;margin-top: 16px">
      <div>手机号：</div>
      <el-input style="width: 200px" v-model="phone"></el-input>
      <div>医院id</div>
      <el-input style="width: 200px" v-model="hid2"></el-input>
      <el-button @click="addDoctorList">提交</el-button>
    </div>
    <div style="margin-top: 32px">添加医生到MDT(1-惠州立德 2-顺德社区测试1 3-顺德中医院 4-南海医院)</div>
    <div style="display: flex;justify-items: center;margin-top: 16px">
      <div>手机号：</div>
      <el-input style="width: 200px" v-model="phone"></el-input>
      <div>mdt domian id</div>
      <el-input style="width: 200px" v-model="domian"></el-input>
      <el-button @click="addDomain">提交</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RegisterHospital',
  data () {
    return {
      tableDataHospitals: [],
      formAddHospital: {
        name: '',
        ivCode: '',
        sort: 10,
        defaultDoctorPhone: '18520535303',
        createHospitalAdmin: true,
        isOpenSmsNotify: '1'
      },
      formRules: {
        name: [{ required: true, message: '请输入医院名称', trigger: 'blur' }],
        sort: [{ required: true, message: '请输入排序值', trigger: 'change' }],
        defaultDoctorPhone: [{ required: true, message: '请输入默认服务医生手机号', trigger: 'blur' }]
      },
      submitting: false,
      hospitalAdminDialogVisible: false,
      adminSubmitting: false,
      adminHospital: {},
      adminMobiles: '',
      hospitalAdminListDialogVisible: false,
      adminListLoading: false,
      adminListHospital: {},
      hospitalAdmins: [],
      testPatientPhone: '',
      testPatients: [],
      testPatientSearching: false,
      testPatientSearched: false,
      testingPatientId: '',
      phone: '',
      hid: '',
      hid2: '',
      domian: ''
    }
  },
  mounted () {
    this.getHosiptals()
  },
  methods: {
    async searchTestPatient () {
      const phone = this.testPatientPhone.trim()
      if (!/^\d{6,20}$/.test(phone)) {
        return this.$message.warning('请输入有效的患者手机号')
      }

      this.testPatientSearching = true
      this.testPatientSearched = false
      this.testPatients = []
      try {
        const { data: resp } = await this.$http.get('cms/patient/phone', { params: { phone } })
        if (resp.code !== 200) return this.$message.error(resp.message)
        const page = resp.data || {}
        this.testPatients = (page.content || []).map(patient => {
          const hospital = this.tableDataHospitals.find(item => Number(item.hospitalId) === Number(patient.hospitalCode))
          const isOpenSmsNotify = hospital ? hospital.isOpenSmsNotify : null
          return {
            ...patient,
            hospitalName: patient.hospital || patient.registerHospital || (hospital && hospital.name) || '未绑定医院',
            isOpenSmsNotify: isOpenSmsNotify === true || isOpenSmsNotify === '1' || isOpenSmsNotify === 1
          }
        })
        this.testPatientSearched = true
      } catch (error) {
        this.$message.error(error.message || '患者搜索失败')
      } finally {
        this.testPatientSearching = false
      }
    },
    async testPlanSms (patient) {
      const hospitalName = patient.hospital || patient.registerHospital || '未绑定医院'
      try {
        await this.$confirm(
          `将向患者 ${patient.realname || ''}（${patient.phone}）实际发送一条训练方案短信，所属医院：${hospitalName}。`,
          '确认测试发送',
          { type: 'warning' }
        )
        this.testingPatientId = patient.userId
        const { data: resp } = await this.$http.post('cms/hospital/test-plan-sms', null, {
          params: { phone: patient.phone }
        })
        if (resp.code !== 200) return this.$message.error(resp.message)
        this.$message.success(`短信已发送至 ${resp.data.phone}，所属医院：${resp.data.hospitalName}`)
      } catch (error) {
        if (error !== 'cancel' && error !== 'close') {
          const responseData = error.response && error.response.data
          this.$message.error((responseData && (responseData.message || responseData.msg)) || error.message || '测试发送失败')
        }
      } finally {
        this.testingPatientId = ''
      }
    },
    async addDomain () {
      console.log('手机号', this.phone)
      console.log('domian', this.domian)

      const { data: resp } = await this.$http.post('regist/setDoctorMDT', {
        phone: this.phone,
        hid: this.domian
      })
      if (resp.code !== 200) return this.$message.error(resp.message)
      this.$message.success(resp.message)
    },
    async addDoctorList () {
      console.log('手机号', this.phone)
      console.log('hid2', this.hid2)

      const { data: resp } = await this.$http.post('regist/setDoctorList', {
        phone: this.phone,
        hid: this.hid2
      })
      if (resp.code !== 200) return this.$message.error(resp.message)
      this.$message.success(resp.message)
    },
    async add () {
      console.log('手机号', this.phone)
      console.log('hid', this.hid)

      const { data: resp } = await this.$http.post('regist/setDoctor', {
        phone: this.phone,
        hid: this.hid
      })
      if (resp.code !== 200) return this.$message.error(resp.message)
      this.$message.success(resp.message)
    },
    async getHosiptals () {
      const { data: resp } = await this.$http.get('regist/hospitals')
      console.log(resp)
      if (resp.code !== 200) return this.$message.error(resp.message)
      this.tableDataHospitals = resp.data
    },
    async addWxMiniAppWebModel (hospital) {
      try {
        await this.$confirm(
          `确认将“${hospital.name}”加入小程序 WebView 医院配置吗？`,
          '提示',
          {
            type: 'warning'
          }
        )
        const { data: resp } = await this.$http.post(
          'regist/hospitals/wx-mini-app-web-model',
          null,
          {
            params: {
              hospitalId: hospital.hospitalId
            }
          }
        )
        if (resp.code !== 200) return this.$message.error(resp.message)
        this.$message.success(resp.message || '添加成功')
        await this.getHosiptals()
      } catch (error) {
        if (error !== 'cancel' && error !== 'close') {
          this.$message.error(error.message || '添加失败')
        }
      }
    },
    openHospitalAdminDialog (hospital) {
      this.adminHospital = hospital
      this.adminMobiles = ''
      this.hospitalAdminDialogVisible = true
    },
    async openHospitalAdminListDialog (hospital) {
      this.adminListHospital = hospital
      this.hospitalAdmins = []
      this.hospitalAdminListDialogVisible = true
      this.adminListLoading = true
      try {
        const { data: resp } = await this.$http.get('api/hospital/user/listByHospital', {
          params: {
            hospitalId: hospital.hospitalId
          }
        })
        if (resp.code !== 200) return this.$message.error(resp.message)
        this.hospitalAdmins = resp.data || []
      } finally {
        this.adminListLoading = false
      }
    },
    async submitHospitalAdmins () {
      const mobiles = Array.from(new Set(
        this.adminMobiles
          .split(/[\s,，、;；]+/)
          .map(item => item.trim())
          .filter(Boolean)
      ))
      if (!mobiles.length) {
        return this.$message.warning('请至少填写一个医生手机号')
      }

      this.adminSubmitting = true
      try {
        const { data: resp } = await this.$http.post('api/hospital/user/batchAdd', {
          hospitalId: this.adminHospital.hospitalId,
          mobiles: mobiles
        })
        if (resp.code !== 200) return this.$message.error(resp.message)

        const result = resp.data || {}
        let message = `新增 ${result.added || 0} 人，已存在 ${result.skipped || 0} 人`
        if (result.failed && result.failed.length) {
          message += `，失败 ${result.failed.length} 人：${result.failed.join('；')}`
        }
        this.$message.success(message)
        this.hospitalAdminDialogVisible = false
      } finally {
        this.adminSubmitting = false
      }
    },
    async onSubmit () {
      this.$refs.form.validate(async valid => {
        if (!valid || this.submitting) return
        this.submitting = true
        try {
          const { data: resp } = await this.$http.post('regist/add', this.formAddHospital)
          if (resp.code !== 200) return this.$message.error(resp.message)

          const result = resp.data || {}
          let message = `添加成功，医院ID：${result.hospitalId}，注册医院ID：${result.registerHospitalId}，邀请码：${result.inviteCode}`
          if (result.hospitalAdminUserId && result.hospitalAdminPassword) {
            message += `，管理端账号：${result.hospitalAdminUserId}，密码：${result.hospitalAdminPassword}`
          }
          this.$message.success(message)
          await this.getHosiptals()
          this.resetForm()
        } finally {
          this.submitting = false
        }
      })
    },
    resetForm () {
      this.formAddHospital = {
        name: '',
        ivCode: '',
        sort: 10,
        defaultDoctorPhone: '18520535303',
        createHospitalAdmin: true,
        isOpenSmsNotify: '1'
      }
      this.$nextTick(() => {
        if (this.$refs.form) this.$refs.form.clearValidate()
      })
    },
    async toggleSmsNotify (row) {
      const newStatus = !row.isOpenSmsNotify
      try {
        const { data: resp } = await this.$http.post('cms/hospital/update-sms-notify', null, {
          params: {
            registerHospitalId: row.id,
            isOpen: newStatus
          }
        })
        if (resp.code !== 200) return this.$message.error(resp.message)
        this.$message.success(resp.message || '更新成功')
        row.isOpenSmsNotify = newStatus
      } catch (e) {
        console.error('更新短信通知状态失败', e)
        this.$message.error('更新失败')
      }
    }
  }
}
</script>

<style scoped></style>
